import { supabase } from "@/integrations/supabase/client";

export interface EnrichmentStats {
  totalBooks: number;
  needsEnrichment: number;
  hasSynopsis: number;
  hasSeries: number;
  hasPageCount: number;
  hasIsbn: number;
  inUserLibraries: number;
  enrichmentPending: number;
  enrichmentComplete: number;
  enrichmentFailed: number;
}

export async function getEnrichmentStats(): Promise<EnrichmentStats> {
  try {
    const { data, error } = await supabase.rpc('get_enrichment_statistics');

    if (error) {
      console.error('[EnrichmentStats] Error:', error);
      throw error;
    }

    const stats = data?.[0];
    if (!stats) {
      throw new Error('No statistics returned');
    }

    return {
      totalBooks: Number(stats.total_books),
      needsEnrichment: Number(stats.needs_enrichment),
      hasSynopsis: Number(stats.has_synopsis),
      hasSeries: Number(stats.has_series),
      hasPageCount: Number(stats.has_page_count),
      hasIsbn: Number(stats.has_isbn),
      inUserLibraries: Number(stats.in_user_libraries),
      enrichmentPending: Number(stats.enrichment_pending),
      enrichmentComplete: Number(stats.enrichment_complete),
      enrichmentFailed: Number(stats.enrichment_failed)
    };
  } catch (error) {
    console.error('[EnrichmentStats] Failed to fetch:', error);
    throw error;
  }
}

export async function triggerBatchEnrichment() {
  try {
    console.log('[EnrichmentStats] Triggering batch enrichment...');
    
    const { data, error } = await supabase.functions.invoke('scheduled-batch-enrichment');

    if (error) {
      throw error;
    }

    console.log('[EnrichmentStats] Batch enrichment result:', data);
    return data;
  } catch (error) {
    console.error('[EnrichmentStats] Failed to trigger enrichment:', error);
    throw error;
  }
}
